import { Text, Heading, Box, Divider } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

type Props = { children: React.ReactNode };
export const AdvanceRateTemplate = ({ children }: Props) => {
  return (
    <Box p="40px">
      <Box mt="16px">
        <Heading as="h1" mt="16px" mb="16px" fontSize="36px" fontWeight={600}>
          Advance Rate
        </Heading>
        <Text fontSize="16px" mb="16px" color={colors.black[70]}>
          Configure the advance rate for policy and individual accounts.
        </Text>
        <Divider />

        <Text fontSize="14px" mt="16px" mb="16px" color={colors.black[70]}>
          Advance Rates set today will automatically commit the following day at
          1 AM ET, initiating portfolio-wide advance rate recalculations. The
          site will be unavailable at this time.
        </Text>
      </Box>
      <Box mt="32px">{children}</Box>
    </Box>
  );
};
